@if (autoAlert && replyAlert && !hasReplyConfirmed) {
  <div
    class="alert-product-card bolt-row"
    >
    <div class="bolt-col">
      <div class="top-row">
        <div class="text">
          <bolt-icon
            name="exclamation-triangle-filled"
            color="theme-warning"
            size="sm"
          ></bolt-icon>
          <div class="title">{{ autoAlert.productType | formatProductName }} Alerts</div>
        </div>
        <div class="spacer"></div>
        <div class="buttons">
          <bolt-button
            type="solid"
            size="sm"
            (click)="openReplyModal()"
            >
            Submit reply
          </bolt-button>
          <bolt-button
            type="outline"
            size="sm"
            (click)="navigateToAddDriver()"
            >
            Add driver
          </bolt-button>
        </div>
      </div>
      @if (replyAlert.message) {
        <div class="message">
          {{ replyAlert.message }}
        </div>
      }
    </div>
  </div>
}
